import React, { FC } from 'react';
import { useStore } from '@/components/store/Store';
import { useTranslation } from 'react-i18next';
import { BlockItemPathPrefix } from '@/declarations/models/BlockItemPathPrefix';
import { ChildrenProp } from '@/declarations/ChildrenProp';
import { DamsMediaItem } from '@/declarations/models/DamsMediaResponse';
import { Settings } from '@/Settings';
import Container from '../../../../../components/Container';
import Image from '../../../../../components/Image';
import CaptionInput from '../CaptionInput';
import MediaItemImage from '../MediaItemImage';

export interface DamsContentProps {
  item: DamsMediaItem;
  pathPrefix: BlockItemPathPrefix;
  // editMedia: () => void;
}

export const M24Content: FC<DamsContentProps & ChildrenProp> = ({ children, item, pathPrefix }) => {
  const {
    state: { selectedSite },
  } = useStore();
  const { t } = useTranslation('components');
  // const altText = item?.content?.alttext;

  // let imgMimeType = '';
  // if (item.mimetype?.includes('png')) {
  //   imgMimeType = `mediaType=${item.mimetype}`;
  // }
  const damsEmsDomain = Settings.viteEnvironmentIsProduction ? 'ems.dimu.org' : 'ems-test.dimu.org';
  const imageSrc = item.m24?.ems_id ? `https://${damsEmsDomain}/image/${item.m24.ems_id}?&dimension=250x250` : '';

  return (
    <Container p={2} column fullWidth>
      <Container gap={2} top spaceBetween fullWidth>
        <Container column sx={{ maxWidth: '200px' }} left fullWidth>
          <MediaItemImage pathPrefix={pathPrefix} src={imageSrc} title={item.title}>
            <Image
              src={imageSrc}
              title={item.title}
              // alt={altText}
              sx={{ maxWidth: '200px' }}
              // focusPoint={{
              // x: item.x || item.local?.x || '0',
              // y: item.y || item.local?.y || '0',
              // }}
            />
          </MediaItemImage>

          {/* {!altText && ( */}
          {/*  <Container px={1}> */}
          {/*    <MaterialSymbol name='error' fill color='error' /> */}
          {/*    <Typography variant='caption' color='error'> */}
          {/*      {t('M24Content.MissingAltTextWarning')} */}
          {/*    </Typography> */}
          {/*  </Container> */}
          {/* )} */}
          {/* {item.site_id === selectedSite?.id && ( */}
          {/*  <Button */}
          {/*    sx={{ */}
          {/*      typography: 'caption', */}
          {/*      textAlign: 'left', */}
          {/*      '&:hover': { textDecoration: 'underline' }, */}
          {/*    }} */}
          {/*    startIcon={<MaterialSymbol name='edit' fill />} */}
          {/*    onClick={editMedia}> */}
          {/*    {t('M24Content.EditGlobalMediaData')} */}
          {/*  </Button> */}
          {/* )} */}
        </Container>

        <CaptionInput
          toggleCaptionVisibilityPath={`${pathPrefix}.local.disableCaption`}
          captionPath={`${pathPrefix}.local.caption`}
          // placeholder={item?.content?.caption}
          hint={t('M24Content.CaptionHint')}
        />
      </Container>
      {/* {item.type === 'video' && (
  <Container px={1} fullWidth>
    <CheckboxInput
      path={`${pathPrefix}.local.portraitmode`}
      fullWidth={true}
      label={t('M24Content.ForcePortraitMode')}
    />
  </Container>
)} */}
      <Container px={1} fullWidth>
        {children}
      </Container>
      <Container px={1} right fullWidth>
        {/* <Typography variant='caption'>M24-ID: {item.id}</Typography> */}
      </Container>
    </Container>
  );
};

export default M24Content;
